import React, { memo } from "react"
import PropTypes from "prop-types"
import { getMonthDates, getBookingsForDay } from "../../utils/calendarHelpers"
import styles from "../../EquipmentCalendar.module.css"
import { getJournalIcon } from "pagesV2/pro/Calendar/utils"
import IconWithBg from "ui/IconWithBg"
import moment from "moment"
import { Text } from "ui/Typography"
import { Flex } from "antd"

/**
 * Month view calendar component
 * Displays a monthly calendar grid with bookings
 */
const MonthView = ({ selectedDate, assets, selectedAsset, onViewMoreClick, onBookingClick }) => {
  const monthDates = getMonthDates(selectedDate)

  return (
    <div className={styles.monthGrid}>
      {/* Header Row with Days of Week */}
      <div className={styles.monthGridHeader}>
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
          <div key={day} className={styles.monthDayHeader}>
            <Text type="secondary">{day}</Text>
          </div>
        ))}
      </div>

      {/* Calendar Grid Body */}
      <div className={styles.monthGridBody}>
        {monthDates.map((dateObj) => {
          const bookings = getBookingsForDay(dateObj.date, assets, selectedAsset)
          const maxVisible = 3
          const visibleBookings = bookings.slice(0, maxVisible)
          const hiddenCount = bookings.length - maxVisible

          const cellClassName = dateObj.isCurrentMonth ? styles.monthDayCell : `${styles.monthDayCell} ${styles.otherMonth}`

          return (
            <div key={dateObj.date.toISOString()} className={cellClassName}>
              <Flex justify="center" align="center" className={styles.monthDayNumber}>
                <div className={styles.dayNumberTextContainer}>
                  <Text type={dateObj.isCurrentMonth ? "primary" : "secondary"} className={styles.dayNumberText}>
                    {dateObj.dayNumber}
                  </Text>
                </div>
                <IconWithBg icon={getJournalIcon([], moment(dateObj.date).format("YYYY-MM-DD"))} />
              </Flex>

              {/* Bookings List */}
              <div className={styles.monthBookingsList}>
                {visibleBookings.map((booking) => (
                  <button
                    key={booking.id}
                    className={`${styles.monthBookingItem} ${
                      booking.paymentStatus === "full_paid" ? styles.paidBooking : styles.outstandingBooking
                    }`}
                    aria-label={`Open booking ${booking.tripName} at ${booking.timeRange}`}
                    onClick={() => onBookingClick(booking.uuid)}
                    type="button"
                  >
                    <Text className={styles.monthBookingTime}>
                      {booking.timeRange}
                      <br />
                      <span className={`${styles.tripText} ${styles.ellipsisText} ellipsis`}>{booking.tripName}</span>
                    </Text>
                  </button>
                ))}
                {hiddenCount > 0 && (
                  <button type="button" className={styles.viewMoreLink} onClick={() => onViewMoreClick(dateObj.date)}>
                    <Text type="link" className={styles.viewMoreText}>
                      View more
                    </Text>
                  </button>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

MonthView.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  assets: PropTypes.array.isRequired,
  selectedAsset: PropTypes.string.isRequired,
  onViewMoreClick: PropTypes.func.isRequired,
  onBookingClick: PropTypes.func.isRequired
}

export default memo(MonthView)
